@if (mainImage$ | async; as main) {
  @if (product$ | async; as product) {
    <cx-media [container]="main"
      [alt]="product?.name"
      (touchmove)="touchMove($event, main)"
      (click)="clickStart(true)"
      (mousedown)="mouseDownSlide($event)"
    (mouseup)="mouseUpSlide($event, main)"></cx-media>
    <cx-product-image-zoom-trigger
      (dialogClose)="clickStart(false)"
      [galleryIndex]="selectedIndex"
    ></cx-product-image-zoom-trigger>
  }
  @if (thumbs$ | async; as thumbs) {
    <div [class]="thumbs.length ? 'margin-bottom-150':''">
      @if (isMobile() | async) {
        @if (thumbs.length) {
          <cx-carousel
            class="thumbs"
            [items]="thumbs"
            [itemWidth]="(thumbs.length >= 4) ? (100 / thumbs.length+  '%') : slideSize"
            [hideIndicators]="true"
            [template]="thumb"
            [animation]="animation"
            [enableMouseActions]="false"
          ></cx-carousel>
        }
      } @else {
        @if (thumbs.length) {
          <cx-carousel
            class="thumbs"
            [items]="thumbs"
            [itemWidth]="slideSize"
            [hideIndicators]="true"
            [template]="thumb"
            [animation]="animation"
            [enableMouseActions]="false"
            [activeMainItem]="getActiveIndex(main)"
            (updateMainImage)="openImage($event)"
          ></cx-carousel>
        }
      }
    </div>
  }
  <ng-template #thumb let-item="item">
    @if (product$ | async; as product) {
      <cx-media
        [alt]="product?.name"
        [container]="item.container"
        tabindex="0"
        (focus)="openImage(item.container)"
        [class.is-active]="isActive(item.container) | async"
        format="product"
        >
      </cx-media>
    }
  </ng-template>
}
